module.exports = __webpack_public_path__ + "media/src/application/images/logo-8862ece148177b50c4082c54a8424aec.svg";